import ReferenceBlock from './ReferenceBlock';

globalThis.ReferenceComponents = {
  ReferenceBlock,
};
